import {Injectable} from '@angular/core';

import {PluralLabelsEnum} from '../enums/PluralEnums';

@Injectable()
export class PluralService {
  constructor() {}

  getPluralString(
    enumVariable: any,
    itemsCount: number,
    upperFirst: boolean
  ): string {
    let str = enumVariable[PluralLabelsEnum[PluralLabelsEnum.ZERO]].toString();
    if (itemsCount === 1) {
      str = enumVariable[PluralLabelsEnum[PluralLabelsEnum.SINGLE]].toString();
    } else if (itemsCount > 1) {
      str = enumVariable[PluralLabelsEnum[PluralLabelsEnum.MULTI]].toString();
    }
    return upperFirst
      ? str
        ? str.charAt(0).toUpperCase() + str.slice(1)
        : ''
      : str;
  }
}
